import { render, staticRenderFns } from "./ChangeOperationsByUsers.vue?vue&type=template&id=5b96f380&scoped=true"
import script from "./ChangeOperationsByUsers.vue?vue&type=script&lang=js"
export * from "./ChangeOperationsByUsers.vue?vue&type=script&lang=js"
import style0 from "./ChangeOperationsByUsers.vue?vue&type=style&index=0&id=5b96f380&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b96f380",
  null
  
)

export default component.exports